import styles from './Footer.module.scss';
import DecatronLogo from '../../assets/icons/decatron_white_logo.png';
import AmplifyLogo from '../../assets/icons/aws-amplify-logo.png';
import LinkedinIcon from '../../assets/icons/linkedin_white.svg';
import WhatsappIcon from '../../assets/icons/whatsapp.svg';
import InstagramIcon from '../../assets/icons/instagram_white.svg';
export default function Footer() {
    return (
        <footer className={styles.footer_container}>
            <div className={styles.content}>
                <h3>Nossas Redes</h3>
                <div className={styles.icons}>
                    <a
                        href="https://www.instagram.com/decatronoficial"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={InstagramIcon} alt="Instagram ícone" className={styles.insta} />
                    </a>
                    <a
                        href="https://www.linkedin.com/company/decatron"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={LinkedinIcon} alt="Linkedin ícone" className={styles.linkedin} />
                    </a>
                    <a
                        href="https://web.whatsapp.com/send?phone=552139064000&text=Ol%C3%A1,%20estava%20dando%20uma%20olhada%20no%20site%20e%20tenho%20algumas%20d%C3%BAvidas.%20Pode%20me%20ajudar?"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={WhatsappIcon} alt="Whatsapp ícone" className={styles.wpp} />
                    </a>
                </div>
            </div>
            <div className={styles.decatron_box}>
                <div className={styles.decatron_logo}>
                    <img src={DecatronLogo} alt="Logo" />
                </div>

                <section className={styles.footer_host}>
                    <p>Hosted by: </p>
                    <img src={AmplifyLogo} alt="Logo Amplify" />
                </section>
            </div>
        </footer>
    );
}
